module.exports = __webpack_public_path__ + "img/time-car@2x.c142cfe8.png";